import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-log",
  "use": "icon-log-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-log\"><defs><style type=\"text/css\"></style></defs><path d=\"M752.3 171.1V72.9h-50v98.2H321.7V72.9h-50v98.2H64v780h896v-780H752.3z m157.7 730H114v-680h157.7v51.8h50v-51.8h380.5v51.8h50v-51.8H910v680zM244.8 442.9h53.3v50h-53.3v-50z m0 204.6h53.3v50h-53.3v-50z m133.3 0h426.7v50H378.1v-50z m0-204.6h426.7v50H378.1v-50z\" fill=\"\" p-id=\"1965\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol